import { render, staticRenderFns } from "./stap-4.vue?vue&type=template&id=25be33b4&"
import script from "./stap-4.vue?vue&type=script&lang=js&"
export * from "./stap-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingHoofdrichtingen: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Hoofdrichtingen.vue').default,InschrijvingPraktijkgegevens: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Praktijkgegevens.vue').default,InschrijvingAssessorAfspraak: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/AssessorAfspraak.vue').default,InschrijvingNavigation: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/navigation.vue').default})
